<template>
  <v-container fluid>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Impressões</v-toolbar-title>
      </v-app-bar>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="impressoes"
      :loading="loading"
      no-data-text="Sem registros"
      no-results-text="Sem registros"
      hide-default-footer
    >
      <template v-slot:item.time="{ item }">
        <v-chip>{{ item.time }}</v-chip>
      </template>
      <!-- <template v-slot:item.acoes="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              icon
              small
              @click="marcarComoLido(item)"
            >
              <v-icon dark>mdi-check</v-icon>
            </v-btn>
          </template>
          <span>Marcar como lido</span>
        </v-tooltip>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import Moment from "moment";
import ServiceImpressoes from "@/services/impressoes.js";

export default {
  name: "Impressoes",
  data() {
    return {
      impressoes: [],
      loading: true,
      headers: [
        { text: "Enviado", value: "time", width: "96px" },
        { text: "Descrição", value: "descricao", width: "100%" },
        { text: "Status", value: "status", width: "64px" },
      ],
    };
  },

  mounted() {
    ServiceImpressoes.listarImpressoesPendentes()
      .then(({ impressoes }) => {
        this.impressoes = this.montarLista(impressoes);
        setInterval(() => this.montarLista(this.impressoes), 1000);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    montarLista(impressoes) {
      return impressoes.map((impressao) => {
        return {
          ...impressao,
          //           var duration = moment.duration(now.diff(end));
          // var days = duration.asDays();
          time: new Moment(impressao.data).locale("pt-br").fromNow(),
        };
      });
    },
  },
};
</script>

<style scoped></style>
